export const WITHOUT_USER_ITEM_ID = "__none__";
